import { Component, HostBinding, Input, OnInit, inject, input } from '@angular/core';
import { MediaService } from '@exl-ng/mulo-core';
import { UrlUtils } from '../../shared/utils/url.utils';
import { ResearcherRecord } from '../../shared/interfaces/researcher-record.interface';
import { I18nService } from '../../core/i18n.service';
import { ResearcherTitlePipe } from '../../shared/pipes/researcher-title.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

import { HorizontallerComponent, HorizontallerItemComponent, AvatarComponent } from '@exl-ng/mulo-common';

@Component({
    selector: 'esp-portal-researchers',
    templateUrl: './portal-researchers.component.html',
    styleUrls: ['./portal-researchers.component.scss'],
    imports: [
        HorizontallerComponent,
        HorizontallerItemComponent,
        AvatarComponent,
        RouterLink,
        TranslateModule,
        ResearcherTitlePipe
    ]
})
export class PortalResearchersComponent implements OnInit {
    media = inject(MediaService);
    i18nService = inject(I18nService);

    readonly researchers = input<ResearcherRecord[]>(undefined);
    // TODO: Skipped for migration because:
    //  This input is used in combination with `@HostBinding` and migrating would
    //  break.
    @HostBinding('style.--researchers-to-display')
    @Input()
    researchersToDisplay = 3;

    institution = UrlUtils.getParam('institution');

    ngOnInit(): void {}
}
